import { lazy } from 'react';
import { msg } from '@/lib/i18n';
import { registerInvalidation } from '@/lib/realtime';
import { registerEntityHref } from '@/ui';
import { registerEntityTab } from '../entityTabs';
import { defineModule } from '../types';
import { mediaKeys } from './api';
import { mediaAliasRoute, mediaModuleAliasRoute, mediaVideoAliasRoute, requestRoute, videoRoute } from './routes';

/**
 * Media (server module `media`): the video library, requests and their states, the request
 * wizard, footage availability, the monthly quota and auto-video flows. Its pages live under
 * Activity › Video (the Activity nav item lists it); it adds a Video tab to vehicles and trips.
 */
export const mediaModule = defineModule({
  key: 'media',
  routes: [videoRoute, requestRoute, mediaAliasRoute, mediaVideoAliasRoute, mediaModuleAliasRoute],
  nav: [],
  setup() {
    registerEntityTab('vehicle', {
      key: 'video',
      label: msg('Video'),
      order: 60,
      permission: 'media.video.read',
      module: 'media',
      component: lazy(() => import('./tabs/VehicleVideoTab')),
    });
    registerEntityTab('trip', {
      key: 'video',
      label: msg('Video'),
      order: 20,
      permission: 'media.video.read',
      module: 'media',
      component: lazy(() => import('./tabs/TripVideoTab')),
    });
    registerEntityHref('video', (id) => `/activity/video?video=${id}`);
    registerEntityHref('video_request', (id) => `/activity/video?tab=requests&request=${id}`);

    // Requests change state on the server (drain, upload, expiry): refresh what shows them.
    registerInvalidation('vehicle', (n) => (n.type.startsWith('media.') ? [mediaKeys.all] : []));
    registerInvalidation('project', (n) => (n.type === 'media.quota.reached' ? [['media', 'quota']] : []));
  },
});
